<template>
    <dash
        icon="fa fa-book"
        titulo="CONTRATAÇÕES SGF"
        subTitulo="APOIO"
        @click.native="$router.push({ name: 'Apoios_Contratacoes' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
